import axios from 'axios';

if (document.querySelector('[name="api-token"]')) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${
        document.querySelector('[name="api-token"]')?.content
    }`;
}

export class ApiService {
    constructor() {
        this.axios = axios;
        this.apiBaseUrl = window.apiUrl;
    }

    async Get(url) {
        return this.axios.get(this._getApiUrl(url)).then(this._mapResponse);
    }

    async Post(url, payload = {}) {
        return this.axios
            .post(this._getApiUrl(url), payload)
            .then(this._mapResponse);
    }

    async Put(url, payload = {}) {
        return this.axios
            .put(this._getApiUrl(url), payload)
            .then(this._mapResponse);
    }

    async Delete(url) {
        return this.axios.delete(this._getApiUrl(url)).then(this._mapResponse);
    }

    _getApiUrl(url) {
        return this.apiBaseUrl + url;
    }

    _mapResponse(response) {
        return response.data;
    }
}
